import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { ClientService } from '@teem/services/client.service';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { client as ClientApi } from '@teem/constants/api';
import { PAYMENT_TYPES } from '@teem/constants/invoice';
import { parseDate } from '@teem/helpers/functions';

declare var $;

@Component({
	selector: 'record-payment-modal',
	templateUrl: './record-payment-modal.component.html',
	styleUrls: ['./record-payment-modal.scss']
})
export class RecordPaymentModalComponent implements OnInit {
	paymentForm: FormGroup;
	paymentTypes: Array<object> = PAYMENT_TYPES;
	invoices: Array<any> = [];
	invoiceNumber: string;
	submitted: boolean = false;
	clientListApi: string = ClientApi.list;
	selectedClient: any;
	@Input('userInfo') userInfo: any;
	@Input('invoice') invoice: any;

	constructor(
		private fb: FormBuilder,
		public activeModal: NgbActiveModal,
		private el: ElementRef,
		private clientService: ClientService,
		private invoiceService: InvoiceService,
		private loaderService: LoaderService,
	) {
	}

	ngOnInit(): void {
		this.paymentForm = this.fb.group({
			client_id: [null, Validators.required],
			invoice_id: [null, Validators.required],
			amount: [this.invoice?.due_amount, [Validators.required, Validators.min(0.01)]],
			payment_type: [null, Validators.required],
			other_note: [null, [Validators.required]],
			date: [moment().format('DD/MM/YYYY'), Validators.required]
		});

		// console.log(this.invoice);
		if (this.invoice && this.invoice.client_uuid) {
			this.clientService.get(this.invoice.client_uuid).subscribe((client) => {
				this.selectedClient = {
					id: client.id,
					full_name: client.full_name,
					email: client.email
				}
				this.paymentForm.get('client_id').setValue(client.id);
				this.clientService.invoices(this.invoice.client_uuid, { type: 'unpaid' }).subscribe((data: any) => {
					this.loaderService.stopLoading();
					this.invoices = data;
					this.paymentForm.get('invoice_id').setValue(this.invoice.id);
					this.invoiceNumber = this.invoice.invoice_number;
					setTimeout(() => {
						$('select[nice-select]').niceSelect('update');
					}, 100);
				}, err => {
					this.loaderService.stopLoading();
				})
			})
		}
	}

	onChangeClient(value: any) {
		if (value) {
			this.loaderService.startLoading();
			this.clientService.invoices(value.uuid, { type: 'unpaid' }).subscribe((data: any) => {
				this.loaderService.stopLoading();
				this.invoices = data;
			}, err => {
				this.loaderService.stopLoading();
			})
		} else {
			this.paymentForm.get('invoice_id').setValue(null);
			this.paymentForm.get('invoice_id').updateValueAndValidity();
		}
	}

	onChangeProject(value: any) {
		if (value && this.invoices && this.invoices.length) {
			let invoice = this.invoices.find(obj => obj.id == value);

			if (invoice) {
				this.invoiceNumber = invoice.invoice_number;
				this.paymentForm.get('amount').setValidators([
					Validators.required,
					Validators.min(0.01),
					Validators.max(parseFloat(invoice.due_amount))
				]);
			} else {
				this.invoiceNumber = null;
			}

		} else {
			this.invoiceNumber = null;
		}
	}

	checkOptionIsAvailable(option) {
		if (option == 'credit-card') {
			return this.userInfo?.halala_mobile ? true : false
		}
		if (option == 'cash') {
			return this.userInfo?.accept_cash_payment ? true : false;
		}
		return true;
	}

	submit() {
		this.submitted = true;
		if (this.paymentForm.valid) {

			let fd = this.paymentForm.value;
			fd.date = parseDate(fd.date);
			fd.invoice_number = this.invoiceNumber;

			this.loaderService.startLoading();

			this.invoiceService.createPayment(this.paymentForm.value).subscribe(data => {
				this.loaderService.stopLoading();
				Swal.fire('', i18n.invoice.payment_saved, 'success');
				this.activeModal.close(data);
			}, err => {
				this.loaderService.stopLoading();

				if (err.status == 422) {
					if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;

						Object.keys(validationErrors).forEach((prop) => {
							this.paymentForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}

				// Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			})
		}
	}

	isNoteFieldEnabled() {
		if (this.paymentForm.value.payment_type === 'other') {
			this.paymentForm.get("other_note").enable();
		} else {
			this.paymentForm.get("other_note").disable();
		}
	}
}